"use client";

import React from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";

export interface WizardStepDef {
  id: number;
  title: string;
  description: string;
}

export interface WizardProgressProps {
  steps: WizardStepDef[];
  currentStep: number;
  className?: string;
}

export function WizardProgress({ steps, currentStep, className = "" }: WizardProgressProps) {
  return (
    <div className={`bg-gradient-to-br from-[color:var(--agent-surface-from)] to-[color:var(--agent-surface-to)] border border-[color:var(--agent-surface-border)] rounded-2xl p-3 min-[1440px]:p-6 shadow-sm my-4 min-[1440px]:my-6 ${className}`}>
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center flex-1">
            <div className="flex items-center">
              <motion.div
                initial={{ scale: 0.8, opacity: 0.5 }}
                animate={{ 
                  scale: currentStep >= step.id ? 1 : 0.8,
                  opacity: currentStep >= step.id ? 1 : 0.5 
                }}
                className={`w-8 h-8 min-[1440px]:w-12 min-[1440px]:h-12 rounded-xl min-[1440px]:rounded-2xl flex items-center justify-center font-bold text-sm min-[1440px]:text-base transition-all duration-300 ${
                  currentStep > step.id
                    ? 'text-green-600'
                    : currentStep === step.id
                    ? 'text-[color:var(--agent-accent)]'
                    : 'text-gray-400'
                }`}
              >
                {currentStep > step.id ? (
                  <Check className="w-4 h-4 min-[1440px]:w-6 min-[1440px]:h-6" />
                ) : (
                  step.id
                )}
              </motion.div>
              
              <div className="ml-4 hidden min-[1440px]:block">
                <p className={`font-semibold ${
                  currentStep >= step.id ? 'text-gray-900' : 'text-gray-400'
                }`}>
                  {step.title}
                </p>
                <p className={`text-sm ${
                  currentStep >= step.id ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  {step.description}
                </p>
              </div>
            </div>
            
            {index < steps.length - 1 && (
              <div className="flex-1 mx-4 hidden min-[1440px]:block">
                <div className={`h-1 rounded-full transition-colors duration-300 ${
                  currentStep > step.id ? 'bg-[color:var(--agent-accent)]' : 'bg-gray-200'
                }`} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
